import { Box, Typography } from "@mui/material"
import processImg from "../assets/images/process.png";

const process= [
    {
      "title": "Agricultural Waste Collection",
      "description": "The process begins by sourcing agricultural residues such as crop stalks, husks, and other byproducts directly from farmers. This not only provides an additional revenue stream for the farming community but also prevents agricultural waste from being burned or discarded, reducing environmental pollution and greenhouse gas emissions."
    },
    {
      "title": "Sustainable Bio Fuel Production",
      "description": "The collected agricultural waste is processed to extract fermentable sugars, which are converted into Biofuel through an eco-friendly fermentation and distillation process. By utilizing renewable biomass, this phase significantly reduces reliance on fossil fuels, contributing to a cleaner, greener energy ecosystem."
    },
    {
      "title": "Byproduct Generation – Organic Fodder",
      "description": "A key outcome of the Bio Fuel production process is Dry Distilled Grain Solubles (DDGS), a protein-rich, organic byproduct. This high-quality feed is supplied to livestock and poultry industries, offering farmers an affordable and nutritious alternative for animal rearing. This fosters a symbiotic relationship where the farming community benefits both as suppliers of raw materials and recipients of value-added products."
    },
    {
      "title": "Environmental and Economic Impact",
      "description": "By replacing traditional fossil fuels, biofuel reduces greenhouse gas emissions and supports the Union Government’s Biofuel Blending Programme. The closed-loop process ensures zero waste, promotes carbon neutrality, and minimizes the ecological footprint of energy production. Additionally, farmers gain dual economic benefits: payment for agricultural waste and access to organic fodder, which reduces feed costs and enhances livestock productivity."
    },
    {
      "title": "Empowering Farmers and Rural Communities",
      "description": "This circular model uplifts the farming community by creating a sustainable value chain. It enhances farmer incomes, promotes resource efficiency, and integrates rural economies into the renewable energy ecosystem."
    },
    {
      "title": "Closing the Loop",
      "description": "The process completes the cycle by ensuring that every output serves a purpose, either as renewable energy or as a resource for further agricultural productivity. This innovative approach not only supports energy independence but also strengthens the rural economy and contributes to long-term environmental sustainability."
    }
  ]

const WhoWeAre = () => {
    return(
        <Box sx={{  pt: {xs: 5, md: 15}, px: {xs: 4, md: 20}, mb: {xs: 4, md: 0}, textAlign: "left", gap: '20px',  }}>
            <Box sx={{mb: 1}}>
                <Typography variant="h3" gutterBottom sx={{ lineHeight: "60px", width:{ xs: "100%", md: "40%"}}} >
                Who we are
                </Typography>
            </Box>
            <Box sx={{ padding: {xs: 0, md: "0 80px" } }}>
            <img src={processImg} width="100%" style={{boxSizing: 'border-box',}} />
            </Box>
            <Box sx={{flex: "1 1"}} mb={6}>
                <Typography flex='1 1' fontWeight="bold" variant="subtitle1" margin='auto'>
                Closed-Loop Bio Fuel Production Cycle: Enhancing Sustainability and Farmer Welfare
                </Typography>
                {
                    process.map((el, index)=>(<>
                            {/* <span style={{fontWeight: "bold", float: "left"}}>{index+1}.</span> */}
                                <Typography fontWeight="bold" variant="subtitle1" margin='auto'>
                                {index+1}. {el.title}
                                </Typography>
                                <Typography variant="subtitle1" ml={2.5} >
                                    {el.description}
                                </Typography>
                    </>))
                }
            </Box>
            <Typography flex='1 1' fontWeight="bold" variant="subtitle1" margin='auto'>
            Key Takeaway
            </Typography>
            <Typography flex='1 1' variant="subtitle1" margin='auto'>
            The closed-loop Bio Fuel production cycle exemplifies a holistic approach to renewable energy by integrating waste-to-energy conversion with farmer empowerment. It is a model of sustainability that turns agricultural waste into biofuel and organic fodder, delivering economic, social, and environmental value to the farming community and the nation at large.
            </Typography>
        </Box>
    )
}

export default WhoWeAre;